import { Autocomplete, Pagination, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { primary } from '../../Styles/theme'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { PPage } from '../../Libs/Constants/size';

const optionsPerPage = ['25', '50', '100', '200']

interface IProps {
  onChagePage?: any
  onChangeRowsPerPage?: any
  quantity: number
}

export function PPagination(props: IProps) {
  const [curPage, setCurPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(PPage)
  const [numPage, setNumPage] = useState(
    Math.ceil(props.quantity / PPage),
  )

  useEffect(() => {
    setCurPage(1);
    setNumPage(Math.ceil(props.quantity / rowsPerPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.quantity, rowsPerPage])

  //--------------------------------------------------//
  //--------------------------------------------------//
  ///// Table /////
  const handleChangeRowsPerPage = (event: any, value: string | null) => {
    setRowsPerPage(Number(value))
    setNumPage(Math.ceil(props.quantity / Number(value)))

    setCurPage(1)
    props.onChangeRowsPerPage(Number(value))
  }

  const handleChangePage = (e: React.ChangeEvent<unknown>, value: number) => {
    setCurPage(value)
    props.onChagePage(value)
  }

  //--------------------------------------------------//
  //--------------------------------------------------//
  return (
    <div className="dis-flex flex-row flex-r-m">
      <Typography variant="body2" color="secondary">
        แสดง
      </Typography>
      <Autocomplete
        sx={{ px: 1, color: 'red' }}
        options={optionsPerPage}
        value={rowsPerPage.toString()}
        disableClearable
        size="small"
        renderInput={(params) => (
          <TextField {...params} color="primary" focused label="" />
        )}
        popupIcon={<ArrowDropDownIcon sx={{ color: primary }} />}
        onChange={handleChangeRowsPerPage}
      />
      <Typography variant="body2" color="secondary">
        รายการ
      </Typography>
      <Pagination
        color="primary"
        defaultPage={1}
        siblingCount={1}
        onChange={handleChangePage}
        count={numPage}
        page={curPage}
      />
    </div>
  )
}
